import { formatRelative, format as dateFnsFormat } from "date-fns";
import { ptBR } from "date-fns/locale";

export function getMonthName(value) {
  const monthNames = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ];
  const date = new Date(value);
  return monthNames[date.getMonth()];
}

export function formatDate(value) {
  const date = value.split("/");
  return `${date[1]}/${date[0]}/${date[2]}`;
}

export function relative(date) {
  return formatRelative(new Date(date), new Date(), { locale: ptBR });
}

export function format(date) {
  return dateFnsFormat(new Date(date), "dd/MM/yyyy");
}
